module.exports = __webpack_public_path__ + "static/media/oDonnell.5ba188a2.png";